skrilla.controller('createAffiliateCodeCtrl', function ($scope, searchService, modalService, validationService, cacheService, srefService) {
    var validation = validationService;
    $scope.definition = cacheService.getObjectOrElse("promotionDefinition", modalService.dismissAll)
    $scope.validate = {}
    if($scope.definition.purpose === "BTAG_REFERRAL"){
        $scope.isBtagReferral = true;
        $scope.code = {
            userClaimable: true,
            code: null
        }
        $scope.isAffiliate = true
    }else {
        $scope.isBtagReferral = false;
        $scope.code = {
            userClaimable: false,
            code: null
        }
        $scope.isAffiliate = false
    }



    $scope.select = function(affiliate){
        $scope.selectedAffiliate = affiliate;
        $scope.code.ownerId = affiliate.id;
    }
    $scope.searchAffiliates = function(){
        searchService.get("affiliates").then(function(response){
            $scope.affiliates = response.data.result;
        });
    }
    $scope.addExpiryMinutes = function(minutes){
        let code = $scope.code;
        const expiresInMinutes = (code.expiresInMinutes || 0) + minutes;
        $scope.code = {...code,  expiresInMinutes}
    }

    $scope.create = function(){
        $scope.code.ownerType = $scope.isAffiliate ? "AFFILIATE" : null;
        if(validate()) {
            modalService.confirm("Are you sure you'd like to create this code?", function () {
                searchService.get("promotions/codes/" + $scope.code.code + "/isAvailable").then(function (response) {
                    if (response.data === true) {
                        searchService.post("promotions/definitions/" + $scope.definition.id + "/codes",  $scope.code, "Affiliate Code successfully created.").then(function (response) {
                            modalService.dismissAll();
                            srefService.go("promotionCodeAndClaims", {id: response.data.id})
                        })
                    }
                    else {
                        swal("Error!", "This code is not available", "error");
                    }
                });
            });
        }
    }

    function validate(){
        var inputs = [
            validation.buildFieldValidationObj("code", !validation.isEmpty($scope.code.code), "Please enter a code"),
            validation.buildFieldValidationObj("ownerId", !$scope.isAffiliate || !validation.isEmpty($scope.code.ownerId), "Please select an affiliate")
        ];
        return validation.validateForm(inputs, $scope.validate)
    }

});
